/**
 * printer.js
 */

define(
        'printer',
        ["moment", "Seed", "Seed.Tab"],
        function (moment, Seed) {
            "use strict";
            //    methods

            function imprimerForm(
                    pTargetTable,
                    pSourceTable,
                    pKeyValue,
                    pRefreshedList,
                    pCreationAuto,
                    pNumAction,
                    pOwnerKey,
                    pPreviousResult
                    ) {

                var paramElement = "numaction=" + pNumAction;
                paramElement += "&sourcetable=" + pSourceTable;
                // etape 1 : on détermine l'état à imprimer
                var nometat = '';
                if (pTargetTable) {
                    // le nom de l'état était sur yaction.actionsur
                    nometat = pTargetTable;
                } else {
                    // il n'y avait pas de nom dans yaction.actionsur
                    // ==> l'utilisateur a choisi dans une liste déroulante
                    nometat = Seed.Tab.GetFrame().find('select#listeedition').val();
                }

                // Traitement du type d'impression
                var infoImpression = nometat.split('/');
                var impressionMode = "";
                if (infoImpression.length === 1) {
                    //        nometat = nometat;
                    impressionMode = "pdf";
                } else if (infoImpression[1] === 'Legacy_PDF') {
                    nometat = infoImpression[0];
                    impressionMode = "pdf";
                } else {
                    nometat = infoImpression[0];
                    impressionMode = infoImpression[1];
                }

                paramElement += "&nometat=" + nometat;
                // étape n°2 : on détermine le filtre where
                // vérifier s'il est réellement judicieux de tester pOwnerKey :
                // normalement ça doit servir à imprimer par exemple le tarif
                // client à partir de l'écran du tarif et non pas sur la fiche
                // client.
                // on pourrait trouver d'autres applications d'impression dans
                // les fournitures sur doi, devis; ...

                // pour impression d'un BL on a pownerkey et pkeyvalue
                // ==> il ne faut tester que sur pkeyvalue
                // remarque : on ne test que pKeyValue>0 : on suppose que c'est
                // forcément un bbmindex

                if (pKeyValue > 0) {
                    // on est sur une liste ou dans un formulaire
                    paramElement += "&keyvalue=" + pKeyValue;
                } else {
                    var theContrainte = Seed.Tab.GetFrame().find("#contrainte");
                    if (theContrainte.length !== 0) {
                        paramElement += "&contrainte=" + encodeURI(theContrainte.val());
                    }
                }

                if (pOwnerKey) {
                    paramElement = paramElement + "&ownerKey=" + pOwnerKey;
                }
                // on envoie le previous result pour permettre l'impression dans une chaîne
                // d'action
                if (pPreviousResult) {
                    var sPreviousResultArray = serialize(pPreviousResult, "previousResult");
                    var pnbprevious = pPreviousResult.length;
                    paramElement += "&nbPrevious=" + pnbprevious
                            + sPreviousResultArray;
                }

                var forceWhere = $("#tab_" + Seed.Tab.cTab.attr("id"))
                        .find('#impliciteListeWhere').val();
                if (typeof forceWhere === "undefined") {
                    forceWhere = "";
                }
                if (forceWhere) {
                    forceWhere = '&forceWhere=' + encodeURIComponent(forceWhere);
                }
                function openAll()
                {
                    window.open(root + 'php_impr/globales.php?' + paramElement
                            + forceWhere);
                }
                if (impressionMode === "pdf") {
                    openAll();
                } else if (impressionMode === "ooo") {
                    window.open(root + 'php_impr/openoffice.php?' + paramElement
                            + forceWhere, null);
                } else if (impressionMode === "sendpdf") {
                    window.open(
                            root + 'php_impr/globales.php?' + paramElement
                            + forceWhere,
                            'IMPRESSION',
                            'scrollbars=yes,'
                            + 'width=790,height=610,'
                            + 'top=50,left=225,'
                            + 'resizable=yes'
                            );
                } else {
                    window.open(root + '_module/Impression/impressionTBS.php?'
                            + paramElement + forceWhere, null);
                }

                //                impressionMode = "pdf";
            }


            //            function setMode(pType)
            //            {
            //                impressionMode = pType;
            //            }


            //    exposed public method
            return {
                imprimerForm: imprimerForm
                        //                setMode: setMode
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);

